import React from 'react';
import { Footer } from "flowbite-react";
import {BsFacebook, BsLinkedin, BsGithub, BsGitlab} from "react-icons/bs";
import {graphql, useStaticQuery} from "gatsby";

export default function SocialFooter() {
    const { site: { siteMetadata }} = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    linkedIn
                    facebook
                    github
                    gitlab
                }
            }
        }
    `);

  return (
      <Footer container>
          <Footer.Copyright by="Brooks DuBois™" year={new Date().getFullYear()} />
          <Footer.LinkGroup>
              {/*<Footer.Link href="/profile">About</Footer.Link>*/}
              {/*<Footer.Link href="/contact">Contact</Footer.Link>*/}
              <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
                  <Footer.Icon href={ siteMetadata.linkedIn } icon={BsLinkedin} />
                  {/*<Footer.Icon href={ siteMetadata.facebook } icon={BsFacebook} />*/}
                  <Footer.Icon href={ siteMetadata.gitlab } icon={BsGitlab} />
                  <Footer.Icon href={ siteMetadata.github } icon={BsGithub} />
              </div>
          </Footer.LinkGroup>
      </Footer>
  );
}

